import { render, staticRenderFns } from "./paperDetail.vue?vue&type=template&id=7ae0ec30&scoped=true"
import script from "./paperDetail.vue?vue&type=script&lang=js"
export * from "./paperDetail.vue?vue&type=script&lang=js"
import style0 from "./paperDetail.vue?vue&type=style&index=0&id=7ae0ec30&prod&scoped=true&lang=less"
import style1 from "./paperDetail.vue?vue&type=style&index=1&id=7ae0ec30&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae0ec30",
  null
  
)

export default component.exports